<template>
  <div class="member-level-record-item">
    <p class="dateTime">{{ displayData.dateTime }}</p>
    <div v-if="displayData.user" class="row">
      <p class="label">{{ $t('member.memberLevelDetail.operator') }}</p>
      <p>{{ displayData.user }}</p>
    </div>
    <div class="row">
      <p class="label">{{ displayData.source }}</p>
      <p>{{ record.originLevel || $t('member.memberLevelDetail.noLevel') }} {{ $t('member.memberLevelDetail.levelLabel') }} → {{ record.level || $t('member.memberLevelDetail.noLevel') }} {{ $t('member.memberLevelDetail.levelLabel') }}；{{ $t('member.memberLevelDetail.levelExpiryLabel') }} {{ displayData.expiredDate }}</p>
    </div>
    <div class="row">
      <p class="label">{{ $t('member.memberLevelDetail.recognitionStartDate') }}</p>
      <p>{{ displayData.recognizedStartedAt }}</p>
    </div>
    <div v-if="displayData.operatingShopName" class="row">
      <p class="label">{{ $t('member.memberLevelDetail.upgradeDowngradeStore') }}</p>
      <p>{{ displayData.operatingShopName }}</p>
    </div>
    <div class="row">
      <p class="label">{{ $t('member.memberLevelDetail.note') }}</p>
      <p>{{ record.note ? record.note : '-' }}</p>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { get } from 'lodash'
import { t } from '@/plugins/i18n/i18n'
import { formatDate } from '@/utils/date'
import { memberLevelRecordSourceConfig } from '@/config/memberLevel'

export default defineComponent({
  name: 'MemberLevelRecordItem',
  props: {
    record: { type: Object, default: () => ({}) },
  },
  setup (props) {
    const displayData = computed(() => {
      const data = props.record
      const sourceType = get(data, 'source')

      let expiredDate
      const expiredAt = get(data, 'expiredAt')
      if (!expiredAt) expiredDate = t('member.memberLevelDetail.permanent')
      else expiredDate = formatDate(expiredAt)

      const recognizedStartedAt = get(data, 'recognizedStartedAt')

      return {
        user: get(data, 'User.name'),
        dateTime: formatDate(get(data, 'updatedAt'), 'YYYY/MM/DD HH:mm'),
        expiredDate,
        source: get(memberLevelRecordSourceConfig, `${sourceType}.label`),
        recognizedStartedAt: recognizedStartedAt ? formatDate(recognizedStartedAt) : '-',
        // 升降級門市優先顯示實際操作分店（OperatingShop），舊資料無此欄位時 fallback 等級紀錄歸屬店（Shop）
        operatingShopName: get(data, 'OperatingShop.name') || get(data, 'Shop.name'),
      }
    })

    return { get, formatDate, displayData }
  },
})
</script>

<style lang="postcss" scoped>
.label {
  @apply font-bold w-[100px] flex-shrink-0;
}

.row {
  @apply flex gap-[12px];
}
</style>
